// extracted by mini-css-extract-plugin
export var list = "LogoList-module--list--Tbut2";
export var title = "LogoList-module--title--56nvc";